export function parseFolderName(name: string): { title: string; author: string } {
  const prefixed = name.match(/^\[([^\]]+)\]\s*(.+)$/) ?? name.match(/^\(([^)]+)\)\s*(.+)$/)
  if (prefixed?.[1].trim() && prefixed[2].trim()) {
    return { title: prefixed[2].trim(), author: prefixed[1].trim() }
  }
  const separated = name.match(/^(.+?)\s+-\s+(.+)$/)
  if (separated?.[1].trim() && separated[2].trim()) {
    return { title: separated[1].trim(), author: separated[2].trim() }
  }
  return { title: name, author: '' }
}
